module.exports = __webpack_public_path__ + "static/img/weezie_bi.ff2970a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_bi.png
// module id = 6yvG
// module chunks = 0